const R = require('ramda')
const SCI = require('sci')
const Promise = require('bluebird')
const agent = require('superagent')
const $ = require('jquery')
const modal = require('./modal')
const vueChaos = require('./vue-chaos')
const { url } = require('../utils')
const PromiseQueue = require('promise-queue')

PromiseQueue.configure(Promise)

const $loading = $('#global-loading')
const $queuedLoading = $('.global-queued-loading')

const template = require('templates/double-password-request.hbs')

const DEFAULT_QUEUE = Symbol('DEFAULT_QUEUE')
const queues = {
    [DEFAULT_QUEUE]: new PromiseQueue(4, Infinity)
}

class BaseClient {
    constructor () {
        this.queue = DEFAULT_QUEUE
        this.download = false
        this.isSilent = false
        this.isBlocked = false
        this.isBackground = false
        this.$blockedContainer = null
        this.el = null
        this.files = {}
        this.formData = null
        this.onProgressFn = null
        this.secureModalMessage = 'Este registro será excluído permanentemente. Se você concorda e deseja continuar com a exclusão definitva dessa informação clique no botão abaixo.'
        this.secureModalButton = 'Excluir registro definitivamente'
    }

    url (path) {
        throw new Error('Client must implement `url(path)` method.')
    }

    background () {
        this.isBackground = true
        return this
    }

    block ($container) {
        this.$blockedContainer = $($container)

        this.$blockedContainer
            .removeClass('blockable')
            .addClass('blockable')
            .addClass('blocked')
        this.isBlocked = true

        return this
    }

    silent (value = true) {
        this.isSilent = value
        return this
    }

    onProgress (fn) {
        this.onProgressFn = fn
        return this
    }

    showShoutMessage (message) {
        if (this.isBackground) return

        $loading
            .removeClass('is-not-loading')
            .addClass('is-loading')
            .find('.message')
            .html(message || 'Carregando...')
        return this
    }

    hideShoutMessage (message) {
        if (this.isBackground) return

        $loading
            .removeClass('is-loading')
            .addClass('is-not-loading')
    }

    showSilentMessage (message) {
        if (!message) return
        if (this.isBackground) return

        const $queue = $('#loading-queue')
        const $spinner = $queue.find('> .queue-spinner')

        this.el = $queuedLoading
            .clone()

        if (!$spinner.hasClass('is-loading')) {
            $spinner.addClass('is-loading')
        }

        $queue.find('> .queue')
            .append(this.el)

        this.el
            .find('.message')
            .html(message || 'Carregando...')

        this.el.css('display', 'block')
    }

    hideSilentMessage () {
        if (this.isBackground) return

        if (this.el) {
            this.el.remove()

            if ($('#loading-queue > .queue > *').length < 1) {
                $('#loading-queue > .queue-spinner').removeClass('is-loading')
            }
        }
    }

    showMessage (message) {
        if (this.isBackground) return

        if (this.isSilent) {
            this.showSilentMessage(message)
        } else {
            this.showShoutMessage(message)
        }
    }

    hideMessage () {
        if (this.isBlocked) {
            this.$blockedContainer.removeClass('blocked')
        }

        if (this.isBackground) return

        if (this.isSilent) {
            this.hideSilentMessage()
        } else {
            this.hideShoutMessage()
        }
    }
    isDownload() {
        this.download = true
        return this;
    }

    execute (message, instance) {
        this.showMessage(message)

        return queues[this.queue].add(() => {
            return new Promise((resolve, reject) => {
                const startedWhen = new Date().getTime()
                let speedSamples = []
                let downloaded = 0
                let lastProgress = new Date().getTime()

                const token = SCI.get('token')
                if (this.download === false) {
                    instance.set('Accept', 'application/json')
                } else {
                    instance.responseType('blob')
                }
                instance.set('X-Authorization', token ? `Bearer ${token}` : undefined)
                instance.set('Authorization', token ? `Bearer ${token}` : undefined)
                instance.set('X-Timezone', new Date().getTimezoneOffset() / 60)

                instance
                    .on('progress', (event) => {
                        if (this.onProgressFn && event.direction === 'upload') {
                            const diffSinceLastProgress = new Date().getTime() - lastProgress

                            lastProgress = new Date().getTime()

                            const now = new Date().getTime()
                            const timeDiff = now - startedWhen

                            const timeDiffSeconds = timeDiff / 1000

                            const downloadedNow = event.loaded - downloaded
                            downloaded = event.loaded

                            speedSamples = R.takeLast(9, speedSamples).concat([{ size: downloadedNow, time: diffSinceLastProgress }])

                            const wastedTime = R.pipe(R.map(_ => _.time), R.sum)(speedSamples)
                            const downloadedSize = R.pipe(R.map(_ => _.size), R.sum)(speedSamples)

                            const downloadSpeed = Math.ceil(downloadedSize / (wastedTime / 1000))

                            const remainingBytes = event.total - event.loaded

                            const remainingTime = Math.ceil(remainingBytes / downloadSpeed)

                            this.onProgressFn(event.percent, event.loaded, event.total, remainingBytes, downloadSpeed, remainingTime, timeDiffSeconds)
                        }
                    })
                    .end((err, response) => {
                        // esse timeout serve para eyecandy da tela de loading
                        this.hideMessage()

                        if (err) {
                            err.hiddenError = true

                            if (!err.response) {
                                return reject(err)
                            }

                            const json = err.response.body
                            const sessionData = window.SESSION_DATA || null

                            if (!IS_DEV && sessionData !== null && json.user === null) {
                                for (const error of json.errors) {
                                    if (error.code === 25) {
                                        location.href = url('/logout?from=trial-expired')
                                        return
                                    }
                                }

                                location.href = url('/error/expired')
                                return
                            } else if (IS_DEV && sessionData !== null && json.user === null) {
                                console.error('[DEV] Sessão possivelmente expirou')
                            }

                            return resolve(json)
                        }

                        return resolve(response.body)
                    })
            })
        })
    }

    secureMessage (message) {
        this.secureModalMessage = message

        return this
    }

    secureButton (message) {
        this.secureModalButton = message

        return this
    }

    secureExecute (message, instance) {
        return new Promise((resolve, reject) => {
            const submitRequest = ($modal, fn = null) => {
                const form = $modal.find('form')
                const password = $modal.find('[name=password]').val()

                instance.set('XDoublePassword', password)

                this
                    .silent()
                    .execute(message, instance)
                    .then((data) => {
                        if (R.pathOr(false, ['meta', 'double-password'], data)) {
                            return vueChaos(form)(data)
                                .then(() => {
                                    $modal.trigger('modal.close')

                                    fn && fn(data)
                                    resolve(data)
                                })
                                .catch((ex) => {
                                    if (!R.pathOr(false, ['meta', 'double-password'], data)) {
                                        $modal.trigger('modal.close')
                                        reject(ex)
                                    }
                                })
                        }

                        fn && fn(data)
                        resolve(data)
                    })
            }

            const $modal = modal({
                title: `<i class="fa fa-lock"></i> Para completar essa ação você precisa redigitar sua senha.`,
                body: template({
                    message: this.secureModalMessage
                }),
                secondaryButton: `Cancelar`,
                primaryButton: this.secureModalButton,
                primaryButtonClass: 'red',
                width: 600,
                onShown: function ($modal) {
                    $modal.find('.form-control')
                        .first()
                        .focus()
                },
                onPrimaryButton: function ($modal, close) {
                    submitRequest($modal, close)
                }
            })

            $modal.find('form').submit(function () {
                submitRequest($modal, () => {
                    $modal.trigger('modal.close')
                })
                return false
            })
        })
    }

    get (message, path, params, config = {}) {
        return this.execute(message, agent.get(this.url(path)).query(params))
    }

    post (message, path, data, config = {}) {
        return this.execute(message, agent.post(this.url(path)).send(data))
    }

    put (message, path, data, config = {}) {
        return this.execute(message, agent.put(this.url(path)).send(data))
    }

    delete (message, path, data, config = {}) {
        return this.execute(message, agent.del(this.url(path)).send(data))
    }
    patch (message, path, data, config = {}) {
        return this.execute(message, agent.patch(this.url(path)).send(data))
    }

    secureDelete (message, path, config = {}) {
        return this.secureExecute(message, agent.del(this.url(path)))
    }

    securePost (message, path, data, config = {}) {
        return this.secureExecute(message, agent.post(this.url(path)).send(data))
    }

    securePut (message, path, data, config = {}) {
        return this.secureExecute(message, agent.put(this.url(path)).send(data))
    }

    attach (key, file) {
        this.files[key] = file
        return this
    }

    setQueue (queue = null) {
        if (queue && !queues.hasOwnProperty(queue)) {
            queues[queue] = new PromiseQueue(1, Infinity)
        }

        this.queue = queue
        return this
    }
}

const setupClient = (Client) => {
    Client.queue = (queue = null) => {
        return new Client()
            .silent()
            .setQueue(queue)
    }
    Client.download = (message, path, params) => {
        return new Client()
            .silent()
            .isDownload()
            .get(message, path, params)
    }
    Client.get = (message, path, params) => {
        return new Client()
            .silent()
            .get(message, path, params)
    }

    Client.post = (message, path, data, config) => {
        return new Client()
            .silent()
            .post(message, path, data, config)
    }

    Client.put = (message, path, data) => {
        return new Client()
            .silent()
            .put(message, path, data)
    }

    Client.patch = (message, path, data) => {
        return new Client()
            .silent()
            .patch(message, path, data)
    }

    Client.delete = (message, path, data) => {
        return new Client()
            .silent()
            .delete(message, path, data)
    }

    Client.secureMessage = (message) => {
        return new Client()
            .secureMessage(message)
    }

    Client.secureDelete = (message, path) => {
        return new Client()
            .silent()
            .secureDelete(message, path)
    }

    Client.securePost = (message, path, data) => {
        return new Client()
            .silent()
            .securePost(message, path, data)
    }

    Client.securePut = (message, path, data) => {
        return new Client()
            .silent()
            .securePut(message, path, data)
    }

    Client.background = (value = true) => {
        return new Client()
            .background(value)
    }

    Client.silent = (value = true) => {
        return new Client()
            .silent(value)
    }

    Client.background = (value = true) => {
        return new Client()
            .background(value)
    }

    Client.block = (value) => {
        return new Client()
            .block(value)
    }

    Client.onProgress = (fn) => {
        return new Client()
            .silent()
            .onProgress(fn)
    }

    Client.url = (path) => {
        return new Client().url(path)
    }

    return Client
}

module.exports = { BaseClient, setupClient }



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/base-client.js